export const ASSET_PRODUCT_TYPE = {
  COMMERCIAL: 'commercial',
  CONSUMER: 'consumer',
};
